
import PageHeading from "@/components/other/PageHeading/PageHeading.vue";
export default {
  name: "CurriculumPageHeading",
  components: { PageHeading },
};
